import React, { useContext } from "react"
import { useSelector } from "react-redux"
import { Form } from "react-bootstrap"
import Select from "react-select"
import { cloneDeep } from "lodash"
import { byId } from "../../../common/jsonapi-filters";
import { AppState } from "../../../reducers";
import ChargeContext from "../../../contexts/ChargeContext"

const Physician = () => {
	const facilities = useSelector((state: AppState) => state.facility.data)
	const physicians = useSelector((state: AppState) => state.physician.data)
	const [charge, setCharge] = useContext(ChargeContext)

	const setPhysician = (physician: any) => {
		const next = cloneDeep(charge)
		next.relationships.physician.data.id = physician.id
		setCharge(next)
	}

	const byPracticeId = (practiceId: number) => (physician: any) => {
		for (let rel of physician.relationships.practice.data) {
			if (rel.id === practiceId) {
				return true
			}
		}

		return false
	}

	return <Form.Group>
		<Form.Label>Physician</Form.Label>
		{
			<Select
				tabIndex={"4"}
				value={physicians.find(byId(charge.relationships.physician.data.id))}

				onChange={setPhysician}

				options={physicians.filter(byPracticeId(facilities.find(byId(charge.relationships.facility.data.id)).relationships.practice.data.id))}

				getOptionLabel={(option: any) => option.attributes.name}
				getOptionValue={(option: any) => option.id}
			/>
		}
	</Form.Group>
}

export default Physician